export default __webpack_public_path__ + "static/media/Bell_pin_light.d5783f83.svg";